import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as v, S as f } from "./icons.types-0722eef5.js";
function u({ title: n, titleId: e, size: i, width: a, height: t, extended: c = !1, ...h }) {
  const r = c ? v : f, o = i ? r[i] : a || r[c ? "s" : "l"], s = i ? r[i] : t || r[c ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: o,
      height: s,
      "aria-labelledby": e,
      ...h,
      children: [
        n ? /* @__PURE__ */ l("title", { id: e, children: n }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Line_chart_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3.658 1.504c1.095 0 2 .814 2.144 1.87l.02.294v62.494l62.51.003c1.094 0 2 .814 2.143 1.87l.02.294a2.164 2.164 0 0 1-1.87 2.145l-.294.02H1.495V3.667c0-1.195.968-2.164 2.163-2.164Zm63.556 20.912c.76.76.837 1.947.228 2.792l-.228.269L46.331 46.36c-.76.76-1.947.837-2.792.228l-.269-.228-10.966-10.963-18.687 18.689c-.76.76-1.946.837-2.792.228l-.268-.228a2.165 2.165 0 0 1-.228-2.792l.228-.269 20.22-20.22a2.165 2.165 0 0 1 2.792-.227l.268.228L44.8 41.766l19.354-19.35a2.164 2.164 0 0 1 3.06 0Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Line_chart_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  u as LineChart
};
